import * as React from "react";
import { Field } from "formik";
import styled from "styled-components";
import FormikInput from "components/common/FormikInput";
import { Input } from "components/bootstrap";
import { TimezoneSelect } from "components/common";
import HoverForHelp from "components/common/HoverForHelp";
const DescriptionTextArea = styled(FormikInput)`
  resize: vertical;
`;
const timezoneLabel = /* @__PURE__ */ React.createElement(React.Fragment, null, "Time zone", /* @__PURE__ */ React.createElement(HoverForHelp, { iconSize: "sm", title: "Time zone", placement: "right" }, "The time zone selected here will be used to display all times in the report."));
const Overview = ({ editAllowed }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(FormikInput, { label: "Title", name: "title", id: "title", required: true, disabled: !editAllowed }), /* @__PURE__ */ React.createElement(
  FormikInput,
  {
    label: /* @__PURE__ */ React.createElement(React.Fragment, null, "Subtitle ", /* @__PURE__ */ React.createElement("small", { className: "text-muted" }, "(Optional)")),
    name: "subtitle",
    id: "subtitle",
    disabled: !editAllowed
  }
), /* @__PURE__ */ React.createElement(
  DescriptionTextArea,
  {
    type: "textarea",
    rows: 3,
    label: /* @__PURE__ */ React.createElement(React.Fragment, null, "Description ", /* @__PURE__ */ React.createElement("small", { className: "text-muted" }, "(Optional)")),
    name: "description",
    id: "description",
    disabled: !editAllowed
  }
), /* @__PURE__ */ React.createElement(Field, { name: "timezone" }, ({ field: { name, value, onChange } }) => /* @__PURE__ */ React.createElement(Input, { id: "timezone-select", label: timezoneLabel, disabled: !editAllowed }, /* @__PURE__ */ React.createElement(
  TimezoneSelect,
  {
    value,
    name: "timezone",
    onChange: (newValue) => onChange({ target: { name, value: newValue } }),
    disabled: !editAllowed
  }
))));
export default Overview;
